var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('el-card',{staticClass:"box-card"},[_c('UploadsTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }